var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 2.5,
    width: 93.5,
    height: 93.5,
    rx: 46.75,
    fill: "#84E1CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 2.5,
    width: 93.5,
    height: 93.5,
    rx: 46.75,
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 50.9375L44.9375 59.375L63.5 40.8125",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.1e12de68a424ad38cd7380305cb68d97.svg";
export { ForwardRef as ReactComponent };